export function getServerUrl(){
    // return "http://localhost:8587";
    return "https://www.qjlong01.top/api";
    // return "http://106.53.40.243/api";
}
